import { FC } from 'react';
import { translate } from '../../i18n';
import { isDesktop } from '../../platform';
import { giftCardPromoStyles } from './styles';
import giftCard from '../../assets/gift-card.svg';
import giftCardIcon from '../../assets/gift-card-icon.svg';
import giftCardButton from '../../assets/gift-card-button.svg';
import plus from '../../assets/icons/plus.svg'

export interface GiftCardPromoProps {
  onPress?: () => void;
  testID?: string;
  accessibilityLabel?: string;
  prompText?: string;
}

/**
 * GiftCardPromo — Tarjeta promocional para códigos de regalo
 *
 * Características:
 * ✅ Icono Carrefour integrado
 * ✅ Estilos centralizados sin Tailwind
 * ✅ Botón (+) con asset
 * ✅ i18n para el texto
 */
export const GiftCardPromo: FC<GiftCardPromoProps> = ({
  onPress,
  testID = 'gift-card-promo',
  accessibilityLabel = translate('paymentsUI.giftCard.label'),
  prompText,
}) => {
  const handleClick = () => {
    onPress?.();
  };

  return (
    <div
      style={giftCardPromoStyles.container}
      data-testid={testID}
      role="button"
      tabIndex={0}
      aria-label={accessibilityLabel}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick();
        }
      }}
      onClick={handleClick}
    >
      {/* Icon */}
      <div
        style={{
          ...giftCardPromoStyles.icon,
          ...(isDesktop ? giftCardPromoStyles.webIcon : {}),
        }}
        data-testid={`${testID}-icon`}
      >
        <img
          src={isDesktop ? giftCard : giftCardIcon}
          alt={translate('paymentsUI.giftCard.label')}
          style={isDesktop ? { height: '32px', width: '32px' } : { width: '25px', height: '24px' }}
        />
      </div>

      {/* Text content */}
      <div style={giftCardPromoStyles.content} data-testid={`${testID}-content`}>
        <p style={giftCardPromoStyles.text} data-testid={`${testID}-text`}>
          {prompText ?? translate('paymentsUI.giftCard.prompt')}
        </p>
      </div>

      {/* Action button */}
      <button
        type="button"
        style={{
          ...giftCardPromoStyles.button,
          ...(isDesktop ? giftCardPromoStyles.webButton : {})
        }}
        data-testid={`${testID}-button`}
        aria-label={translate('paymentsUI.giftCard.addButtonLabel')}
        onClick={(e) => {
          e.stopPropagation();
          handleClick();
        }}
      >
        {
          isDesktop ? (
            <img
              src={plus}
              alt=""
              style={{width: '18px', height: '18px'}}
            />
          ) : (
            <img
              src={giftCardButton}
              alt=""
              style={{ width: '24px', height: '24px' }}
            />
          )
        }
      </button>
    </div>
  );
};
